import { readerImage } from '@/asset/js/utils';
import {
  luckyRechargeInfo,
  luckyRechargeRechargeInfo,
  luckyRechargeDraw,
  luckyRechargeRank,
  luckyRechargeCollect,
  luckyRechargeChangeHideStatus,
  luckyRechargeLottoDraw,
  luckyRechargeRecord,
  luckyRechargeFloatingScreen,
} from '@/services/activity';
import { Toast } from 'antd-mobile';

export default {
  namespace: 'luckyRecharge',
  state: {
    activityId: 0,
    title: '',
    titleUrl: '',
    rules: '',
    endTime: 0,
    activityStatus: null,
    lastId: null,
    selfInfo: {},
    ranks: [],
    recordList: [],
    ticketDrawRewardList: [],
    lottoDrawRewardList: [],
    rechargeCoinNum: 0,
    rechargeRewardList: [],
    ticketNum: 0,
    needCoinNum: 0,
    willGetTicketNum: 0,
    lottoTicketNum: 0,
    sendRewardList: null,
    dailyRechargeStatus: 0,
    dailyRechargeLimit: 0,
    dailyLottoRewardList: [],
    isShowTab: false,
    isShowBoard: false,
  },
  reducers: {
    updateInfo(state, { payload }) {
      return {
        ...state,
        activityId: payload.activityId || '',
        title: payload.title || '',
        titleUrl: payload.titleUrl || '',
        rules: payload.rules || '',
        endTime: payload.endTime || 0,
        activityStatus: payload.activityStatus || 0,
        sendRewardList: payload.sendRewardList || [],
        ticketDrawRewardList: payload.ticketDrawRewardList || [],
        lottoDrawRewardList: payload.lottoDrawRewardList || [],
        rechargeRewardList: payload.rechargeRewardList || [],
        dailyRechargeLimit: payload.dailyRechargeLimit || 0,
        dailyLottoRewardList: payload.dailyLottoRewardList || [],
        isShowBoard: payload.isShowBoard || false,
        isShowTab: payload.isShowTab || false,
      };
    },
    updateRechargeInfo(state, { payload }) {
      return {
        ...state,
        ticketNum: payload.ticketNum || 0,
        rechargeCoinNum: payload.rechargeCoinNum || 0,
        needCoinNum: payload.needCoinNum || 0,
        willGetTicketNum: payload.willGetTicketNum || 0,
        lottoTicketNum: payload.lottoTicketNum || 0,
        dailyRechargeStatus: payload.dailyRechargeStatus || 0,
      };
    },
    updateList(state, { payload }) {
      let list = payload.force ? [] : [...state.ranks];
      let selfInfo = {};
      let lastId = '';
      if (payload.ranks && payload.ranks.length) {
        list = [...list, ...payload.ranks];
        lastId = payload.ranks[payload.ranks.length - 1].userId;
      }
      if (payload.selfInfo && payload.selfInfo.userId) {
        selfInfo = payload.selfInfo;
      }
      const newList = [...list];
      const top3 = list.splice(0, 3);
      const otherList = list;
      const top3List = [top3[1] ? top3[1] : null, top3[0] ? top3[0] : null, top3[2] ? top3[2] : null];
      return {
        ...state,
        selfInfo: selfInfo,
        top3List,
        otherList,
        ranks: newList,
        lastId: lastId,
      };
    },
    updateRecord(state, { payload }) {
      return {
        ...state,
        recordList: payload || [],
      };
    },
  },
  effects: {
    *getInfo({ payload }, { call, put }) {
      const { error, data } = yield call(luckyRechargeInfo, payload);
      if (error || !data) {
        yield put({
          type: 'updateInfo',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      if (data) {
        for (let i = 0; i < data.ticketDrawRewardList.length; i++) {
          const { width, height } = yield readerImage(data.ticketDrawRewardList[i].url);
          let w = 40;
          let h = 40;
          let t = 19.5;
          if (width > height) {
            h = (height / width) * w;
            t = (40 - h) / 2 + t;
          } else if (width < height) {
            w = (width / height) * h;
          } else {
            w = 40;
            h = 40;
          }
          data.ticketDrawRewardList[i].w = w;
          data.ticketDrawRewardList[i].h = h;
          data.ticketDrawRewardList[i].t = t;
        }
        for (let i = 0; i < data.lottoDrawRewardList.length; i++) {
          const { width, height } = yield readerImage(data.lottoDrawRewardList[i].url);
          let w = 60;
          let h = 60;
          let t = 10;
          if (width > height) {
            h = (height / width) * w;
            t = (60 - h) / 2 + t;
          } else if (width < height) {
            w = (width / height) * h;
          } else {
            w = 60;
            h = 60;
          }
          data.lottoDrawRewardList[i].w = w;
          data.lottoDrawRewardList[i].h = h;
          data.lottoDrawRewardList[i].t = t;
        }
        yield put({
          type: 'updateInfo',
          payload: { ...data },
        });
      }
      return true;
    },
    *lottoDraw({ payload }, { call }) {
      const { error, data, code } = yield call(luckyRechargeLottoDraw, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *draw({ payload }, { call }) {
      const { error, data, code } = yield call(luckyRechargeDraw, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getGiftFloatList({ payload }, { call }) {
      const { error, data } = yield call(luckyRechargeFloatingScreen, payload);
      if (error) {
        return {
          error,
          success: false,
        };
      }
      if (data) {
        return data.length ? data : [];
      } else {
        return false;
      }
    },
    *getRechargeInfo({ payload }, { put, call }) {
      const { data, error } = yield call(luckyRechargeRechargeInfo, payload);
      if (error) {
        yield put({
          type: 'updateRechargeInfo',
          payload: [],
        });
        Toast.show({
          content: error,
        });
        return error;
      }
      if (data) {
        yield put({
          type: 'updateRechargeInfo',
          payload: data,
        });
      }
      return true;
    },
    *collect({ payload }, { call }) {
      const { error, data, code } = yield call(luckyRechargeCollect, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.luckyRecharge);
      const { error, data } = yield call(luckyRechargeRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *getPullList({ payload }, { call, put, select }) {
      const { lastId } = yield select(state => state.luckyRecharge);
      const { error, data } = yield call(luckyRechargeRank, { ...payload, lastId: payload.force ? '' : lastId, force: undefined });
      if (error || !data) {
        yield put({
          type: 'updateList',
          payload: {},
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateList',
        payload: { ...data, force: payload.force },
      });
      return true;
    },
    *changeHideStatus({ payload }, { call }) {
      const { error, data, code } = yield call(luckyRechargeChangeHideStatus, payload);
      if (error) {
        return {
          success: false,
          error,
          code,
        };
      }
      if (data) {
        return {
          data,
          success: true,
        };
      } else {
        return false;
      }
    },
    *getRecordList({ payload }, { call, put, select }) {
      const { error, data } = yield call(luckyRechargeRecord, payload);
      if (error || !data) {
        yield put({
          type: 'updateRecord',
          payload: [],
        });
        if (error) {
          Toast.show({
            content: error,
          });
        }
        return false;
      }
      yield put({
        type: 'updateRecord',
        payload: data,
      });
      return true;
    },
  },
};
